module.exports = __webpack_public_path__ + "img/leaf-318743_1920.0df43f21.jpg";